export enum MARKET_FEEDER_MODES {
  LTPC = 'ltpc',
  FULL = 'full',
  OPTION_CHAIN = 'option_chain',
  FULL_D30 = 'full_d30',
  FULL_SR = 'full_sr',
}

export const INITIAL_QUEUE_COLLECTION:
  Record<MARKET_FEEDER_MODES, Array<string>> = {
  [MARKET_FEEDER_MODES.LTPC]: [],
  [MARKET_FEEDER_MODES.FULL]: [],
  [MARKET_FEEDER_MODES.OPTION_CHAIN]: [],
  [MARKET_FEEDER_MODES.FULL_D30]: [],
  [MARKET_FEEDER_MODES.FULL_SR]: [],
};

export const SUBSCRIPTION_MODES = Object.values(MARKET_FEEDER_MODES);

export const DEFAULT_DOM_DETAILS = {
  symbol: '',
  callback(): void {
    throw new Error('Function not implemented.');
  },
};

export const FULL_SUBSCRIPTION_MODES = [
  MARKET_FEEDER_MODES.FULL,
  MARKET_FEEDER_MODES.FULL_D30,
  MARKET_FEEDER_MODES.FULL_SR,
  MARKET_FEEDER_MODES.OPTION_CHAIN,
];
